var configs = {
    scrollOffset: 0,
    updateOffset: 50
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/pagescroll/_configs.js
// module id = 78
// module chunks = 0